const { REACT_APP_API_BASE_URL } = process.env;

export const fixText = (token, text) => new Promise((resolve, reject) => {

  const request = new Request(`${REACT_APP_API_BASE_URL}/chatgpt/fixtext`, {
    method: 'POST',
    headers: {
      'Authorization': `Bearer ${token}`,
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({ text: text })
  });

  fetch(request)
    .then(response => {
      console.log('response', response);
      resolve(response)})
    .catch(err => reject(err));
});
